import { IconButton, Tooltip } from '@mui/material';
import { Eye, EyeOff, Trash2 } from 'lucide-react';
import { useIntl } from 'react-intl';

/** The message ids one annotation kind names its row controls with. */
export interface AnnotationRowLabelIds {
    readonly show: string;
    readonly hide: string;
    readonly delete: string;
}

interface AnnotationRowActionsProps {
    visible: boolean;
    onToggleVisibility: () => void;
    onDelete: () => void;
    labelIds: AnnotationRowLabelIds;
}

/**
 * Show/hide and delete for one row of an annotation list. Both controls carry
 * an aria-label and the toggle its pressed state, so the row stays operable
 * from the keyboard rather than through the tooltip alone (docs/ui_specs.md).
 */
export default function AnnotationRowActions({
    visible,
    onToggleVisibility,
    onDelete,
    labelIds,
}: AnnotationRowActionsProps) {
    const intl = useIntl();
    const visibilityLabel = intl.formatMessage({
        id: visible ? labelIds.hide : labelIds.show,
    });
    const deleteLabel = intl.formatMessage({ id: labelIds.delete });
    return (
        <>
            <Tooltip title={visibilityLabel} placement="left">
                <IconButton
                    size="small"
                    sx={{ p: 0.5 }}
                    aria-label={visibilityLabel}
                    aria-pressed={visible}
                    onClick={onToggleVisibility}
                >
                    {visible ? <Eye size={15} /> : <EyeOff size={15} />}
                </IconButton>
            </Tooltip>
            <Tooltip title={deleteLabel} placement="right">
                <IconButton
                    size="small"
                    sx={{ p: 0.5 }}
                    aria-label={deleteLabel}
                    onClick={onDelete}
                >
                    <Trash2 size={15} />
                </IconButton>
            </Tooltip>
        </>
    );
}
